import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';

import Stakeholders from '../pages/projects/stakeholders/index';
import StakeholderShow from '../pages/projects/stakeholders/show';
import StakeholderSettings from '../pages/projects/stakeholders/settings';
import StakeholderNewStepStakeholder from '../pages/projects/stakeholders/new/step-stakeholder';
import StakeholderNewStepInformation from '../pages/projects/stakeholders/new/step-information';
import StakeholderNewStepGroupParticipants from '../pages/projects/stakeholders/new/step-group-participants';
import StakeholderNewStepCommunicators from '../pages/projects/stakeholders/new/step-communicators';
import StakeholderEditStepStakeholder from '../pages/projects/stakeholders/edit/step-stakeholder';
import StakeholderEditStepInformation from '../pages/projects/stakeholders/edit/step-information';
import StakeholderEditStepGroupParticipants from '../pages/projects/stakeholders/edit/step-group-participants';
import StakeholderEditStepCommunicators from '../pages/projects/stakeholders/edit/step-communicators';

export const stakeholderRoutes = () => (
  <>
    <Route path={ROUTES.STAKEHOLDERS_INDEX} element={<Stakeholders />} />
    <Route
      path={ROUTES.STAKEHOLDERS_SETTINGS}
      element={<StakeholderSettings />}
    />
    <Route path={ROUTES.STAKEHOLDERS_SHOW} element={<StakeholderShow />} />

    {/* Stakeholder New Steps */}
    <Route
      path={ROUTES.STAKEHOLDERS_NEW_STEP_STAKEHOLDER}
      element={<StakeholderNewStepStakeholder />}
    />
    <Route
      path={ROUTES.STAKEHOLDERS_NEW_STEP_INFORMATION}
      element={<StakeholderNewStepInformation />}
    />
    <Route
      path={ROUTES.STAKEHOLDERS_NEW_STEP_GROUP_PARTICIPANTS}
      element={<StakeholderNewStepGroupParticipants />}
    />
    <Route
      path={ROUTES.STAKEHOLDERS_NEW_STEP_COMMUNICATORS}
      element={<StakeholderNewStepCommunicators />}
    />

    {/* Stakeholder Edit Steps */}
    <Route
      path={ROUTES.STAKEHOLDERS_EDIT_STEP_STAKEHOLDER}
      element={<StakeholderEditStepStakeholder />}
    />
    <Route
      path={ROUTES.STAKEHOLDERS_EDIT_STEP_INFORMATION}
      element={<StakeholderEditStepInformation />}
    />
    <Route
      path={ROUTES.STAKEHOLDERS_EDIT_STEP_GROUP_PARTICIPANTS}
      element={<StakeholderEditStepGroupParticipants />}
    />
    <Route
      path={ROUTES.STAKEHOLDERS_EDIT_STEP_COMMUNICATORS}
      element={<StakeholderEditStepCommunicators />}
    />
  </>
);
